import { useState, useMemo } from "react";
import { SelectedNodeIdContext } from "./useSelectedNodeId";
import type {
  SelectedNodeId,
  SelectedNodeIdContextProviderProps,
} from "@app/services/aiFlow.types";

const SelectedNodeIdProvider = ({
  children,
}: SelectedNodeIdContextProviderProps) => {
  const [selectedNodeId, setSelectedNodeId] = useState<SelectedNodeId>(null);
  const values = useMemo(
    () => ({
      selectedNodeId,
      setSelectedNodeId,
    }),
    [selectedNodeId, setSelectedNodeId]
  );

  return (
    <SelectedNodeIdContext.Provider value={values}>
      {children}
    </SelectedNodeIdContext.Provider>
  );
};

export default SelectedNodeIdProvider;
